import React from "react";

function Fees() {
  return (
    <div style={{ minHeight: "80vh", padding: "40px", background: "#f7f8fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", background: "#fff", padding: "30px", borderRadius: "15px", boxShadow: "0 10px 30px rgba(0,0,0,0.05)" }}>
        <h1 style={{ color: "#0b4f6c", marginBottom: "20px", fontSize: "32px" }}>Fees Management</h1>
        <p style={{ color: "#666", fontSize: "18px", marginBottom: "30px" }}>Configure fee structures, track payments, and manage pending dues across all courses.</p>
        
        {/* Placeholder for fees module */}
        <div style={{ padding: "50px", textAlign: "center", border: "2px dashed #e2e8f0", borderRadius: "10px", color: "#94a3b8" }}>
          <h2>Fees Module</h2>
          <p>Coming Soon</p>
        </div>
      </div>
    </div>
  );
}

export default Fees;
